import { UrlConstants } from "../url.constants";
export class ApiModuleRoleConstants {
    static URL = UrlConstants.API_V2 + "ModuleRole";
    static FUNCTION_DELETE_MULTIPLE_MODULE_ROLES = "DeleteMultipleModuleRoles";
    static FUNCTION_DELETE_ALL_MODULE_ROLES = "DeleteAllModuleRoles";
    static FUNCTION_GET_MODULE_ROLES_AND_USERS = "GetModuleRoleAndUsers";
    static FUNCTION_GET_MODULE_ROLES_AND_USERS_INCLUDING_SYSADMIN = "GetModuleRoleAndUsersIncludingSysAdmin";
}
